import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { FulfillmentCompletionsByUserRecord } from "../../../../redux/types/reportTypes";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const headers = [
  {
    label: "User",
    key: "user",
  },
  {
    label: "Association",
    key: "association",
  },
  {
    label: "Association Errors",
    key: "associationErrors",
  },
  {
    label: "Association check",
    key: "associationCheck",
  },
  {
    label: "Check Errors",
    key: "checkErrors",
  },
  {
    label: "Resolution",
    key: "resolution",
  },
  {
    label: "Biz Basics",
    key: "bizBasic",
  },
  {
    label: "Biz Advanced",
    key: "bizAdvance",
  },
  {
    label: "Biz Logo",
    key: "bizLogo",
  },
  {
    label: "Website Entry",
    key: "websiteEntry",
  },
  {
    label: "Ad Design",
    key: "adDesign",
  },
  {
    label: "Design Review",
    key: "designReview",
  },
  {
    label: "Basics Review",
    key: "basicReview",
  },
  {
    label: "Advanced Review",
    key: "advanceReview",
  },
  {
    label: "Duplicate Review",
    key: "duplicateReview",
  },
  {
    label: "Offer Count",
    key: "offerCount",
  },
  {
    label: "Offer Count Resolution",
    key: "offerCountResolution",
  },
];

type UserCSVProps = {
  data: Array<FulfillmentCompletionsByUserRecord>;
};

const UserCSV = ({ data }: UserCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default UserCSV;
